import { SmartAccountType } from "@wallet-manager/node-types/dist/src/postgres/const";
import axios from "./axiosInstance";

export interface IExactPayOperation {
  operation_seq: string;
  amount: string;
  decimals: number;
  // ["USDC", "3000", "USDT", "3000", "USDM"]
  swap_path: string[];
}

export interface IExactGetOperation {
  operation_seq: string;
  amount: string;
  decimals: number;
  // ["USDC", "3000", "USDT", "3000", "USDM"]
  swap_path: string[];
}

export interface SwapRequest<OperationType> {
  merchant_id: number;
  chain_type: number;
  chain_id: number;
  asset_name: string;
  asset_name_get?: string;
  asset_name_pay?: string;
  operations: OperationType[];
}

interface IQuoteExactPayPrice {
  query_results: [
    {
      detail: {
        amount_get_est: number;
      };
      operation_seq: string;
    }
  ];
}

interface IQuoteExactGetPrice {
  query_results: [
    {
      detail: {
        amount_pay_est: number;
      };
      operation_seq: string;
    }
  ];
}

export interface ICurrencyPairRes {
  count: number;
  rows: ICurrencyPair[];
}

export interface ICurrencyPair {
  id: string;
  merchant_id: string;
  chain_type: number;
  chain_id: string;
  symbol: string;
  asset_name1: string;
  asset_name2: string;
  status: number;
  created_date: Date;
  last_modified_date: Date;
}

export interface ISwapPathRes {
  count: number;
  rows: ISwapPathInfo[];
}

export interface ISwapPath {
  fee: number;
  asset_name_to: string;
  asset_name_from: string;
}

export interface ISwapPathInfo {
  id: string;
  merchant_id: string;
  chain_type: number;
  chain_id: string;
  symbol: string;
  asset_name_from: string;
  asset_name_to: string;
  status: number;
  swap_path: ISwapPath[];
  created_date: string;
  last_modified_date: string;
  contract_swap_path: string;
  data_signature: string;
  data_signature_version: number;
  data_signer_server_type: number;
  data_signer_server_id: null;
}

export interface ISwapOrder {
  amount: string;
  from_address: string;
  to_address: string;
  decimals: number;

  // for exact pay
  decimals_get?: number;
  amount_get_est?: string;
  amount_get_min?: string;

  // for exact get
  decimals_pay?: number;
  amount_pay_est?: string;
  amount_pay_max?: string;

  max_slippage: number;
  swap_path: string[];
}
export interface ISwap {
  chain_type: number;
  chain_id: number;
  asset_name: string;
  asset_name_get?: string;
  asset_name_pay?: string;
  smart_account_type: SmartAccountType | undefined;
  orders: ISwapOrder[];
}

export const quoteExactPayPrice = async (
  payload: SwapRequest<IExactPayOperation>
) => {
  return axios.post<never, IQuoteExactPayPrice>(
    "merchant_portal/swap/query_batch_swap_exact_pay",
    payload
  );
};

export const quoteExactGetPrice = async (
  payload: SwapRequest<IExactGetOperation>
) => {
  return axios.post<never, IQuoteExactGetPrice>(
    "merchant_portal/swap/query_batch_swap_exact_get",
    payload
  );
};

export const exactPaySwap = async (payload: ISwap) => {
  return await axios.post<never, any>(
    "/merchant_portal/swap/batch_swap_exact_pay",
    payload
  );
};

export const exactGetSwap = async (payload: ISwap) => {
  return await axios.post<never, ISwap>(
    "/merchant_portal/swap/batch_swap_exact_get",
    payload
  );
};

// query
export const getCurrencyPair = async (payload: {
  chainType: number;
  chainId: number;
  assetStatus?: 1 | -1;
}) => {
  return await axios.get<never, ICurrencyPairRes>(
    "merchant_portal/query/uniswap_assets",
    {
      params: payload,
    }
  );
};
export const getSwapPath = async (payload: {
  chainType: number;
  chainId: number;
}) => {
  return axios.get<never, ISwapPathRes>(
    "merchant_portal/query/uniswap_asset_paths",
    {
      params: payload,
    }
  );
};
